export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1 - 10' },
  { value: '11-50', label: '11 - 50' },
  { value: '51-200', label: '51 - 200' },
  { value: '201-500', label: '201 - 500' },
  { value: '500+', label: '500+' },
];

export const INDUSTRY_OPTIONS = t => [
  {
    value: 'Aerospace & Defense',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.AEROSPACE_DEFENSE'),
  },
  {
    value: 'Agriculture & Food',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.AGRICULTURE_FOOD'),
  },
  {
    value: 'Automotive & Transportation',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.AUTOMOTIVE_TRANSPORTATION'),
  },
  {
    value: 'Chemicals & Materials',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.CHEMICALS_MATERIALS'),
  },
  {
    value: 'Construction & Built Environment',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.CONSTRUCTION_BUILT_ENVIRONMENT'),
  },
  {
    value: 'Consumer Packaged Goods (CPG)',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.CONSUMER_PACKAGED_GOODS'),
  },
  {
    value: 'Education',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.EDUCATION'),
  },
  {
    value: 'Entertainment',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.ENTERTAINMENT'),
  },
  {
    value: 'Finance',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.FINANCE'),
  },
  {
    value: 'Government & Nonprofit',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.GOVERNMENT_NONPROFIT'),
  },
  {
    value: 'Healthcare',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.HEALTHCARE'),
  },
  {
    value: 'Hospitality & Tourism',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.HOSPITALITY_TOURISM'),
  },
  {
    value: 'Industrial & Energy',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.INDUSTRIAL_ENERGY'),
  },
  {
    value: 'Legal & Compliance',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.LEGAL_COMPLIANCE'),
  },
  {
    value: 'Lifestyle & Leisure',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.LIFESTYLE_LEISURE'),
  },
  {
    value: 'Logistics & Supply Chain',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.LOGISTICS_SUPPLY_CHAIN'),
  },
  {
    value: 'Luxury & Fashion',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.LUXURY_FASHION'),
  },
  {
    value: 'News & Media',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.NEWS_MEDIA'),
  },
  {
    value: 'Professional Services & Agencies',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.PROFESSIONAL_SERVICES_AGENCIES'),
  },
  {
    value: 'Real Estate & PropTech',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.REAL_ESTATE_PROPTECH'),
  },
  {
    value: 'Retail & E-commerce',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.RETAIL_ECOMMERCE'),
  },
  {
    value: 'Sports',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.SPORTS'),
  },
  {
    value: 'Technology',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.TECHNOLOGY'),
  },
  {
    value: 'Telecommunications',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.TELECOMMUNICATIONS'),
  },
  {
    value: 'Other',
    label: t('ONBOARDING_NEXT.INDUSTRY_OPTIONS.OTHER'),
  },
];

export const REFERRAL_SOURCE_OPTIONS = t => [
  { value: 'google', label: 'Google' },
  { value: 'reddit', label: 'Reddit' },
  { value: 'twitter', label: 'Twitter/X' },
  { value: 'linkedin', label: 'LinkedIn' },
  {
    value: 'friend',
    label: t('ONBOARDING_NEXT.REFERRAL_SOURCE_OPTIONS.FRIEND'),
  },
  {
    value: 'blog',
    label: t('ONBOARDING_NEXT.REFERRAL_SOURCE_OPTIONS.BLOG'),
  },
  { value: 'github', label: 'GitHub' },
  {
    value: 'other',
    label: t('ONBOARDING_NEXT.REFERRAL_SOURCE_OPTIONS.OTHER'),
  },
];

export const USER_ROLE_VALUES = {
  FOUNDER: 'founder',
  PRODUCT_MANAGER: 'product_manager',
  ENGINEERING: 'engineering',
  SUPPORT_LEAD: 'support_lead',
  MARKETING: 'marketing',
  SALES: 'sales',
  OTHER: 'other',
};
